/* eslint-disable react-hooks/exhaustive-deps */
import { Popover } from 'antd';
import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import Loader from './loader';
import { connect } from 'react-redux';
import { actions } from '../../../../../../store/reducers/authentication';
import TooltipIcon from '../../../../../../components/dashboards/components/TooltipIcon';

const Style = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  width: 100%;
  position: relative;
  overflow: visible;

  .legend-item {
    display: flex;

    p {
      margin-bottom: 0px;
      font-size: var(--font-size-lg);
      font-weight: 500;
    }

    .color {
      width: 8px;
      height: 8px;
      margin-top: 6px;
      border-radius: 100%;
      margin-right: 8px;
    }
  }

  .cadd-legend {
    position: absolute;
    z-index: 100;
    background: white;
    padding: 12px;
    left: 20px;
    bottom: 20px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    gap: 8px;

    .legend-item {
      p {
        font-size: 14px;
        color: #595959;
      }
    }
  }

  header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: var(--font-size-lg); line-height: 22px;
    font-weight: 600;
		font-family: SF UI Display;
    color: #595959;
    padding: 12px;
    border-bottom: 1px solid #CCCCCC;
    width: 100%;

    .legend {
      display: flex;
      gap: var(--size-lg);

      h5 {
        margin-bottom: 0px;
        font-size: var(--font-size-lg);
        font-weight: 600;
        color: #595959;
        line-height: 1.3em;
      }
    }
  }

  .body {
    height: 570px;
    display: flex;
    width: 100%;
    background: #EFF4F8;

    .main {
      flex: 1;
      position: relative;

      .placeholder {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background: white;
        z-index: 100;
      }
    }

    overflow: hidden;

    .toggle-cont {
      height: 80%;
      margin-top: auto;
      margin-bottom: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;
      padding: 8px;
      background: white;
      box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
      border-radius: 4px 0px 0px 4px;
      z-index: 100;
    }
    position: relative;

    .sider {
      background: white;
      width: 230px;
      padding: 9px;
      height: 80%;
      box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
      border-radius: 4px 4px 4px 4px;
      display: flex;
      flex-direction: column;
      margin-right: -230px;
      transition: .4s margin-right;
      margin-top: auto;
      margin-bottom: auto;
      position: absolute;
      right: 0px;
      top: 10%;
      z-index: 400;

      &.toggled {
        margin-right: 0px;
      }

      .main-c {
        flex: 1;
        padding: var(--size-lg);
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .header {
          .contributors-label {
            p {
              color: #111927;
              font-size: 10px;
              font-weight: 600;
              margin-bottom: var(--size-lg);
              margin-top: 4px;
            }
          }
          
          .contributors-icon {
            width: fit-content;
            width: 34px;
            height: 34px;
            border-radius: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            background: rgba(209, 233, 255, 0.5);

            .layer {
              background: #D1E9FF;
              margin-left: auto;
              margin-right: auto;
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: var(--size-lg);
              height: var(--size-lg);
              border-radius: 100%;
              text-align: center;
              color: #384250;
              font-size: 13px;
              font-weight: 500;
            }
          }

          h2 {
            font-size: 14px;
            font-weight: 700;
            color: #384250;
            margin-bottom: 8px;
          }

          p {
            margin-bottom: 0px;
            font-size: 14px;
            font-weight: 500;
            color: #6C737F;
          }
        }

        .bottom p {
          margin-bottom: 0px;
          font-size: 13px;
          font-weight: 500;

          a {
            text-decoration: underline;
          }
        }
      }

      .bottom-c {
        display: flex;
        flex-direction: column;
        padding: 20px;

        a {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }

  &.project-frame {
    background: white;
    background: #FFFFFF;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.16);
    border: 0px;

    header {
      padding: var(--size-lg) 30px;
      border: 0px;
      color: #000000;
      font-size: 20px;
      font-weight: 500;
    }
  }
`;

const PDCCFrame = ({
  title = 'Widget',
  onInit = () => { },
  children,
  t = (s) => s,
  legend = [],
  mB = false,
  activeNode = false,
  layout = 'DEFAULT',
  className = '',
  tooltip,
  toggled,
  setToggled,
}) => {
  const [loading, setLoading] = useState(false);
  const [showPlaceholder, setShowPlaceholder] = useState(false);

  const outActions = useMemo(() => ({
    loading: (state) => {
      setLoading(state);
      if (!state) {
        setTimeout(() => setShowPlaceholder(false), 300);
        return;
      }
      setShowPlaceholder(true);

    },
  }), []);

  useEffect(() => {
    onInit(outActions);
  }, []);

  const renderLegend = () => legend.map((l, i) => (
    <div className="legend-item" key={i.toString()}>
      <div className="color" style={{ background: l.color }} />
      <p>{t(l.label)}</p>
    </div>
  ));

  const renderCaddLegend = () => (
    <div className="cadd-legend">
      {renderLegend()}
    </div>
  );

  useEffect(() => {
    if (activeNode && !toggled) {
      setToggled(true);
    }
  }, [activeNode]);

  return (
    <Style
      style={{ marginBottom: mB ? 24 : 0 }}
      className={className}
    >
      {layout === 'DEFAULT' && (
        <header>
          <div className='flex-row'>
            {title}
            {tooltip && (
              <div className='flex-c jus-c ml-2'>
                <Popover content={tooltip}>
                  <TooltipIcon />
                </Popover>
              </div>
            )}
          </div>
          <div className="legend">
            {renderLegend()}
          </div>
        </header>
      )}
      {layout === 'CADD_PROJECT' && renderCaddLegend()}
      <div className="body">
        <div className="main">
          {children}
          {showPlaceholder && (
            <div className="placeholder" />
          )}
        </div>
        {/* <div className='toggle-cont' onClick={() => setToggled((prev) => !prev)}>
          {toggled ? <RightOutlined /> : <LeftOutlined />}
        </div> */}
      </div>
      {loading ? (
        <Loader />
      ) : null}
    </Style>
  );
}

export default connect(null, { ...actions })(PDCCFrame);
